module.exports = __webpack_public_path__ + "img/mynaui_search.3900d6b4.png";